module.exports = "/images/vendor/flag-icon-css/flags/4x3/bg.svg?3d762564b2be000f52ca9038e8f42ad4";